import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Parking } from 'src/features/parkingManagement/types/parking';
import type { ListDTO, ListResponse } from 'src/types';

const RESOURCE = '/parkings/';

interface DTO extends ListDTO {
    enabled_cash_collection?: boolean;
}

type QueryFnType = typeof queryFn;

const queryFn = ({ ...params }: DTO): Promise<ListResponse<Parking>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });
};

export { useQueryHook as useListAllParkings };
